/* Rock Candy brand page: scroll reveal + sticky shop bar. Safe to load more than once. */
(function () {
  if (window.__rcInit) return;
  window.__rcInit = true;

  var reveal = function (root) {
    var items = (root || document).querySelectorAll('[data-rc-reveal]:not(.rc-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('rc-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rc-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  };

  var sticky = function () {
    var bar = document.querySelector('[data-rc-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-rc-sticky-after]') || document.querySelector('.rc-hero');
    if (!anchor || !('IntersectionObserver' in window)) { bar.classList.add('rc-on'); return; }
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('rc-on', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(anchor);
  };

  var start = function () { reveal(); sticky(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); sticky(); });
})();
